let currentZoomed = null

function toggleZoom(buttonId, imageId, scale) {
  const button = document.getElementById(buttonId)
  const image = document.getElementById(imageId)

  if (currentZoomed && currentZoomed !== imageId) {
    document.getElementById(currentZoomed).style.transform = 'scale(1)'
    document.querySelector('.buttons .active').classList.remove('active')
  }

  if (image.style.transform === `scale(${scale})`) {
    image.style.transform = 'scale(1)'
    button.classList.remove('active')
    currentZoomed = null
  } else {
    image.style.transform = `scale(${scale})`
    button.classList.add('active')
    currentZoomed = imageId
  }
}

document.getElementById('button1').addEventListener('click', function () {
  toggleZoom('button1', 'image1', 1.2)
})
document.getElementById('button3').addEventListener('click', function () {
  toggleZoom('button3', 'image2', 1.2)
})
